export default "__VITE_ASSET__DL$0H9an__"